(function () {
  var endpointUrl = 'https://web.svihej.cz/product_ratings_endpoint.php';

  function cssEscapeValue(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }

    return String(value).replace(/["\\]/g, '\\$&');
  }

  function normalizeRatingNumber(value) {
    var number = parseFloat(value);

    if (isNaN(number)) {
      return null;
    }

    return number;
  }

  function formatRatingValue(value) {
    var number = normalizeRatingNumber(value);

    if (number === null) {
      number = 0;
    }

    return String(number).replace('.', ',');
  }

  function getReviewWord(count) {
    count = parseInt(count, 10) || 0;

    if (count === 1) {
      return 'recenze';
    }

    if (count >= 2 && count <= 4) {
      return 'recenze';
    }

    return 'recenzí';
  }

  function buildStarsHtml(ratingValue, ratingCount) {
    var rating = normalizeRatingNumber(ratingValue);
    var count = parseInt(ratingCount, 10) || 0;

    if (rating === null || count <= 0) {
      rating = 0;
      count = 0;
    }

    var roundedRating = Math.round(rating);
    var starsHtml = '';

    for (var i = 1; i <= 5; i++) {
      starsHtml += '<span class="star ' + (i <= roundedRating ? 'star-on' : 'star-off') + '" aria-hidden="true"></span>';
    }

    var srText = count > 0
      ? 'Průměrné hodnocení produktu je ' + formatRatingValue(rating) + ' z 5 hvězdiček.'
      : 'Produkt zatím nemá hodnocení.';

    return (
      '<div class="ratings-wrapper">' +
        '<div class="stars-wrapper" data-micro-rating-value="' + rating + '" data-micro-rating-count="' + count + '">' +
          '<span class="stars star-list">' +
            starsHtml +
            '<span class="sr-only">' + srText + '</span>' +
          '</span>' +
          '<div class="rating-meta">' +
            '<strong>' + formatRatingValue(rating) + ' z 5</strong>' +
            '<span>' + count + ' ' + getReviewWord(count) + '</span>' +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function getUpsellProductVariants() {
    var variants = [];

    $('.up-after-cart-container [data-product-variant]').each(function () {
      var variant = $.trim($(this).attr('data-product-variant') || '');

      if (variant && variants.indexOf(variant) === -1) {
        variants.push(variant);
      }
    });

    return variants;
  }

  function renderUpsellRating(item) {
    if (!item || !item.product_code) {
      return;
    }

    var code = item.product_code;
    var ratingValue = item.rating_value;
    var ratingCount = item.rating_count;

    if (
      item.last_error ||
      ratingValue === null ||
      ratingValue === '' ||
      ratingCount === null ||
      ratingCount === ''
    ) {
      ratingValue = 0;
      ratingCount = 0;
    }

    var ratingHtml = buildStarsHtml(ratingValue, ratingCount);
    var selector = '.up-after-cart-container [data-product-variant="' + cssEscapeValue(code) + '"]';

    $(selector).each(function () {
      var $variantElement = $(this);
      var $product = $variantElement.closest('.up-product');

      if (!$product.length) {
        return;
      }

      var $content = $product.find('.up-product-content').first();
      var $description = $product.find('.up-product-description-container').first();

      $product.find('.ratings-wrapper').remove();

      if ($description.length) {
        $description.before(ratingHtml);
      } else if ($content.length) {
        $content.prepend(ratingHtml);
      }
    });
  }

  function renderEmptyUpsellRatingsForMissingCodes(variants, returnedCodes) {
    variants.forEach(function (code) {
      if (returnedCodes.indexOf(code) === -1) {
        renderUpsellRating({
          product_code: code,
          rating_value: 0,
          rating_count: 0,
          last_error: 'Product rating not found'
        });
      }
    });
  }

  function loadUpsellRatings() {
    var variants = getUpsellProductVariants();

    if (!variants.length) {
      return;
    }

    $.ajax({
      url: endpointUrl,
      method: 'POST',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      data: JSON.stringify({
        product_variants: variants
      }),
      success: function (response) {
        var returnedCodes = [];

        if (response && response.data && Array.isArray(response.data)) {
          response.data.forEach(function (item) {
            if (item && item.product_code) {
              returnedCodes.push(item.product_code);
            }

            renderUpsellRating(item);
          });
        }

        renderEmptyUpsellRatingsForMissingCodes(variants, returnedCodes);
      },
      error: function (xhr) {
        console.error('Upsell ratings AJAX error:', xhr.status, xhr.responseText);

        variants.forEach(function (code) {
          renderUpsellRating({
            product_code: code,
            rating_value: 0,
            rating_count: 0,
            last_error: 'Rating request failed'
          });
        });
      }
    });
  }

  function runLoadUpsellRatingsDelayed() {
    setTimeout(function () {
      loadUpsellRatings();
    }, 100);
  }

  $(document).ready(function () {
    runLoadUpsellRatingsDelayed();
  });

  document.addEventListener('UpsellCartRendered', function (event) {
    console.log('Upsell cart rendered.');
    console.log('Data:', event.detail);

    runLoadUpsellRatingsDelayed();
  });

  document.addEventListener('UpsellProductRendered', function (event) {
    console.log('Upsell addon rendered on product page.');
    console.log('Data:', event.detail);

    runLoadUpsellRatingsDelayed();
  });

  document.addEventListener('ShoptetDOMCartContentLoaded', function () {
    runLoadUpsellRatingsDelayed();
  });

  document.addEventListener('ShoptetDOMContentLoaded', function () {
    runLoadUpsellRatingsDelayed();
  });

  window.loadUpsellRatings = loadUpsellRatings;
})();